import {
    useCreateController,
    CreateContextProvider,
    Form,
    SaveButton,
    useNotify,
    useTranslate,
    useRefresh,
    FileInput,
    FileField,
    required,
} from 'react-admin';

import {
    DialogTitle,
    DialogContent,
    DialogActions,
    Button as MUIButton,
    Box,
    Typography,
} from '@mui/material';

import { Resources } from '../resource';
import { useState } from 'react';
import useSmartMoneyMetadata from './useSmartMoneyMetadata';

const ImportSmartMoney = ({ onClose }: { onClose: () => void }) => {
    const notify = useNotify();
    const t = useTranslate();
    const refresh = useRefresh();
    const { uploadCSV } = useSmartMoneyMetadata();

    const controller = useCreateController({
        resource: Resources.smartMoney,
    });

    const handleSubmit = async (values: any) => {
        const file = values?.file?.rawFile;

        if (!file) {
            notify('No file selected', { type: 'error' });
            return;
        }

        const formData = new FormData();
        formData.append('file', file);

        try {
            await uploadCSV(formData);

            notify(t('module.smartMoney.importSuccess'), { type: 'success' });
            refresh();
            onClose();
        } catch (error: any) {
            const errorCode = error?.body?.code || error?.code;
            switch (errorCode) {
                case 'FILE_INVALID':
                    notify(t('module.smartMoney.validate.fileInvalid'), { type: 'error' });
                    break;
                default:
                    notify(t('module.smartMoney.unknownErrorImport'), { type: 'error' });
                    break;
            }
        }
    };

    return (
        <CreateContextProvider value={{ ...controller, save: handleSubmit }}>
            <Form onSubmit={handleSubmit} disableInvalidFormNotification>
                <DialogTitle>
                    {t('module.smartMoney.import')}
                    <Typography variant="body2" color="textSecondary" mt={1}>
                        {t('module.smartMoney.validate.csvFormat')}
                    </Typography>
                </DialogTitle>

                <DialogContent>
                    <Box mt={2}>
                        <FileInput
                            label={false}
                            source="file"
                            accept={{ 'text/csv': ['.csv'] }}
                            multiple={false}
                            validate={required()}
                        >
                            <FileField source="src" title="title" />
                        </FileInput>
                    </Box>
                </DialogContent>

                <DialogActions>
                    <MUIButton variant="outlined" onClick={onClose}>
                        {t('actions.cancel')}
                    </MUIButton>
                    <SaveButton />
                </DialogActions>
            </Form>
        </CreateContextProvider>
    );
};

export default ImportSmartMoney;
